import FloorPlansScreen from "./FloorPlansScreen";

export default FloorPlansScreen;
